var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 8.5,
    fill: "#F8F9FA",
    stroke: "#DEE2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6v8M14.5 10h-8",
    stroke: "#868E96",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default SvgPlus20;